
import { mapGetters, mapState } from 'vuex'
import DataTable from '@/mixins/dataTable'
export default {
    mixins: [DataTable],
    props: {
        filter: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            tab: null,
            tabModel: 1,
            api: 'themes/refer-friend/friendList',
            sortBy: 'created_at|desc',
        }
    },
    computed: {
        ...mapState({
            player: (state) => state.player.player,
        }),
        ...mapGetters({
            friendList: 'themes/refer-friend/friendList',
        }),
        friendHeaders() {
            return [
                { text: this.tl('registrationDate'), value: 'created_at' },
                { text: this.tl('playerId'), value: 'player_id' },
                {
                    text: this.tl('betWinLoss'),
                    value: 'total_non_promo_win_loss_amount',
                },
                {
                    text: this.tl('turnover'),
                    value: 'total_non_promo_turnover_amount',
                },
                { text: this.tl('commission'), value: 'total_reward_amount' },
            ]
        },
    },
    watch: {
        filter: {
            deep: true,
            handler(v) {
                this.customFilters = {
                    ...this.customFilters,
                    ...this.filter,
                }
            },
        },
    },
    mounted() {
        this.customFilters = {
            language: this.handleCookie('wl_locale'),
            start_date: this.filter.start_date,
            end_date: this.filter.start_date,
        }
    },
    beforeDestroy() {
        this.doCancelAxiosRequest()
    },
    methods: {
        sumField(data, key) {
            if (data?.data?.length > 0) {
                return data.data.reduce(
                    (a, b) => parseFloat(a) + (parseFloat(b[key]) || 0),
                    0
                )
            } else {
                return 0
            }
        },
    },
}
